<mat-card class="m-auto padding12 connection-card boxshadowgrey">
    <!--<div>
        <button mat-icon-button color="primary" class="back-button" routerLink="/menu">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>-->
    <div class="content">
    <mat-card-title-group class="title-group">
        
        <mat-card-title>{{ "CONNECTION.HEADER" | translate }}</mat-card-title>
    </mat-card-title-group>

    <mat-card-content class="padding6">
        <!-- Backend Status-->
        <mat-card class="margin12_topbottom boxshadowgrey">
            <mat-card-content class="slim-card">
                <div class="status">
                    <div class="values">
                        <div class="values-text text-thick">Backend Status:</div>
                        <mat-chip
                            [ngClass]="{
                                'green-chip': this.backendAlive,
                                'red-chip': !this.backendAlive
                            }"
                        >
                            {{ this.backendAlive ? "Alive" : "Unreachable" }}</mat-chip
                        >
                    </div>
                    <div class="actions">
                        <button mat-stroked-button class="action_btn" color="primary" (click)="checkBackendAlive()" id="checkBackend">
                            <mat-icon>sync</mat-icon> Check Connection
                        </button>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <!-- Gateway Connection Status-->
        <mat-card class="boxshadowgrey">
            <mat-card-content class="slim-card gatewayconnection">
                <div class="status">
                    <div class="values">
                        <div class="values-text text-thick">Gateway Connection:</div>
                        <mat-chip
                            [ngClass]="{
                                'green-chip': this.gatewayConnectionAlive,
                                'red-chip': !this.gatewayConnectionAlive
                            }"
                        >
                            {{ this.gatewayConnectionAlive ? "Connected" : "Not connected" }}</mat-chip
                        >
                    </div>

                    <div class="actions">
                        <button mat-stroked-button class="action_btn" color="primary" (click)="checkGatewayAlive()" id="checkBackend">
                            <mat-icon>sync</mat-icon> Check Connection
                        </button>
                    </div>
                </div>

                <mat-card-actions class="gwconnectaction">
                    <button
                        class="gwconnectbutton, action_btn"
                        mat-stroked-button
                        color="accent"
                        (click)="connectToGateway()"
                        id="connectGateway"
                        [disabled]="this.gatewayConnectionAlive"
                    >
                        <mat-icon>link</mat-icon>Connect
                    </button>

                    <button
                        class="gwconnectbutton, action_btn"
                        mat-stroked-button
                        color="accent"
                        (click)="disconnectFromGateway()"
                        id="disconnectGateway"
                    >
                        <mat-icon>link_off</mat-icon>Disconnect
                    </button>
                </mat-card-actions>
            </mat-card-content>
        </mat-card>

        <!-- Machine Status-->
        <mat-card class="margin12_topbottom boxshadowgrey">
            <mat-card-content class="slim-card">
                <div class="status">
                    <div class="values">
                        <div class="values-text text-thick">Machine Status:</div>
                        <mat-chip
                            [ngClass]="{
                                'green-chip': this.apiGwConnection.machineStatus == 'ONLINE',
                                'red-chip': this.apiGwConnection.machineStatus == 'OFFLINE'
                            }"
                        >
                            {{ this.apiGwConnection.machineStatus == 'ONLINE' ? "Online" : "Offline" }}</mat-chip
                        >
                    </div>
                    <div class="actions">
                        <button mat-stroked-button class="action_btn" color="primary" (click)="checkMachineStatus()" id="checkBackend">
                            <mat-icon>sync</mat-icon> Check Connection
                        </button>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="margin12_topbottom boxshadowgrey">
            <mat-card-content class="slim-card">
                <div class="status">
                    <div class="values">
                        <div class="values-text text-thick">Diagnostic Session:</div>
                    </div>
                    <div class="actions">
                        <button mat-stroked-button class="action_btn" color="primary" (click)="fetchDiagnosticInfo()" id="checkBackend">
                            <mat-icon>sync</mat-icon> Fetch Info
                        </button>
                    </div>
                </div>
                <ng-container *ngIf="fetched">
                    <table mat-table [dataSource]="diagnosticInfo" multiTemplateDataRows>
                        <ng-container *ngFor="let column of columnsToDisplay" matColumnDef="{{column}}">
                            <th mat-header-cell *matHeaderCellDef>{{column}}</th>
                            <td mat-cell *matCellDef="let element">{{column === 'user' || column === 'Machinenumber' || column === 'commonName' ? element[column] : (element[column] | date : "HH:mm:ss.SSS") }}</td>
                        </ng-container>

                        <ng-container matColumnDef="expand">
                            <th mat-header-cell *matHeaderCellDef aria-label="row actions"></th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button aria-label="expand row" (click)="toggle(element); $event.stopPropagation()" class="example-toggle-button" [class.example-toggle-button-expanded]="isExpanded(element)">
                                    <mat-icon>keyboard_arrow_down</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                                <div class="example-element-detail-wrapper" [class.example-element-detail-wrapper-expanded]="isExpanded(element)">
                                    <div class="example-element-detail">
                                        <div class="point">
                                            <div class="point" id="name">Session ID:</div>
                                            <div class="point" id="value">{{element.sessionId}}</div>
                                        </div>
                                        <div class="point">
                                            <div class="point" id="name">Common Name:</div>
                                            <div class="point" id="value">{{element.commonName}}</div>
                                        </div>
                                        <div class="point">
                                            <div class="point" id="name">Diag Session ID:</div>
                                            <div class="point" id="value">{{element.diagSessionId}}</div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
                        <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;" class="example-element-row" [class.example-expanded-row]="isExpanded(element)" (click)="toggle(element)"></tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

                    </table>
                </ng-container>
            </mat-card-content>
        </mat-card>

        <!-- separat Did-call -->
        <ng-container *ngIf="this.gatewayConnectionAlive">
            <mat-expansion-panel class="margin12_topbottom boxshadowgrey">
                <mat-expansion-panel-header>
                    <mat-panel-title class="values-text text-thick">Fetch specific DID data:</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="controls">
                <div class="selection">
                    <mat-form-field class="ecu">
                        <mat-label>ECU</mat-label>
                        <mat-select [(value)]="ecu">
                            <mat-option *ngFor="let ecu of ecus" [value]="ecu.value">{{ecu.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>DID</mat-label>
                        <input 
                        matInput 
                        type="number"
                        [(ngModel)]="did"
                        />
                    </mat-form-field>
                    
                    <button mat-stroked-button color="primary" (click)="addValuePair()" [disabled]="did === undefined || ecu === undefined">ADD</button>
                </div>
                <div class="control_btn">
                    <button mat-stroked-button color="primary" [disabled]="dataSource.data.length === 0 || started" (click)="startDataFetching()">FETCH</button>
                    <button mat-stroked-button color="warn" [disabled]="!started" (click)="stopDataFetching()">STOP</button>
                </div>
                </div>
                <ng-container *ngIf="dataIdentifierList.length > 0">
                    <table mat-table [dataSource]="dataSource">
                        <!-- ECU Column -->
                        <ng-container matColumnDef="ecu">
                            <th mat-header-cell *matHeaderCellDef>ECU ID</th>
                            <td mat-cell *matCellDef="let element"> {{element.ecuId}}</td>
                        </ng-container>
    
                        <!-- Data-ID Column -->
                        <ng-container matColumnDef="did">
                            <th mat-header-cell *matHeaderCellDef>DID ID</th>
                            <td mat-cell *matCellDef="let element">{{element.didId}}</td>
                        </ng-container>
    
                        <!-- Value Column -->
                        <ng-container matColumnDef="value">
                            <th mat-header-cell *matHeaderCellDef>Current Value</th>
                            <td mat-cell *matCellDef="let element">{{element.value}}</td>
                        </ng-container>

                        <!-- Computed Column -->
                        <ng-container matColumnDef="computed">
                            <th mat-header-cell *matHeaderCellDef>Computed Value</th>
                            <td mat-cell *matCellDef="let element">{{element.computed}}</td>
                        </ng-container>
    
                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-stroked-button color="primary" (click)="removeValuePair(element)">
                                    REMOVE
                                </button>
                            </td>
                        </ng-container>
    
                        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    
                    </table>
                </ng-container>
            </mat-expansion-panel>
        </ng-container>

    </mat-card-content>
</div>

</mat-card>
